import type { RouteRecordRaw } from 'vue-router'

import { LEGACY_INGRESSES } from './registry'
import type { ExplicitIngressOutcome, LegacyIngressDefinition } from './types'

export function legacyIngressRouteName(id: string): string {
  return `legacy-ingress:${id}`
}

function isExplicit(
  definition: LegacyIngressDefinition,
): definition is LegacyIngressDefinition & { outcome: ExplicitIngressOutcome } {
  return definition.outcome.kind !== 'v4'
}

/**
 * Generated before the generic catch-all. These records are product-honesty surfaces, not a
 * fourth global guard: auth/permission/cancellation remain the exact contract-05 guard chain.
 */
export const legacyIngressRoutes: RouteRecordRaw[] = LEGACY_INGRESSES.filter(isExplicit).map(
  (definition) => ({
    path: definition.path,
    name: legacyIngressRouteName(definition.id),
    component: () => import('./IngressOutcomeView.vue'),
    props: { ingressId: definition.id },
    meta: {
      layout: 'app',
      requiresAuth: true,
      titleKey: 'shell.ingress.pageTitle',
    },
  }),
)
